import {IPortalseite, ISchueler_testsAPI, ITestheftAPI, TFach} from "./Interfaces";
import {IErgebnisseDB, ISchuelerDB} from "./InterfacesDB";
import Veraportal from "./Veraportal";
import Utilities from "./Utilities";
import VeraApi from "./VeraApi";
import FachGruppeFilter from "./FachGruppeFilter";
import Modal from "./Modal";
import Tooltip from './Tooltip';
import Statistik from './Statistik';

export default class Ergebnisdateneingabe extends Veraportal implements IPortalseite {
    private tmp_ItemIndex = 0;
    private tmp_ItemxPos = 0;
    private tmp_ItemyPos = 0;

    private get readonlyMode(): boolean {
        return this.sessionvariablen.projekt.weiche === 'vera5' && this.sessionvariablen.get['readonly'] !== 'false';
    }

    override async onSeiteLoad(): Promise<boolean> {
        let filter: FachGruppeFilter;
        if (this.sessionvariablen.user.accounttyp !== 5)
            filter = new FachGruppeFilter(this, this.gruppenliste, this.sessionvariablen.get['fach'], this.sessionvariablen.get['gruppeid']);
        else
            filter = new FachGruppeFilter(
                this,
                this.gruppenliste,
                this.gruppenliste.filter(g => g.gruppe_id === this.sessionvariablen.user.gruppe_id)[0]?.kurs_fach as TFach,
                this.sessionvariablen.user.gruppe_id, true
            );

        filter.setGruppeFach();
        if (filter.gruppeId === null)
            return false;

        const filterGruppe = this.gruppenliste.filter(g => g.gruppe_id === filter.gruppeId)[0] ?? null;

        const druckfach = document.querySelector<HTMLElement>(`#ergebnisdaten-druckfach`);
        const druckgruppe = document.querySelector<HTMLElement>(`#ergebnisdaten-druckgruppe`);
        if (druckfach !== null)
            druckfach.textContent = Utilities.printFachLang(filter.fach);
        if (druckgruppe !== null)
            druckgruppe.textContent = filterGruppe.bezeichnung;

        const schuelerInGruppe: ISchuelerDB[] = this.schuelerliste
            .filter(
                s =>
                    this.schuelerGruppenZuweisungen
                        .filter(x => x.gruppe_id === filterGruppe.gruppe_id)
                        .map(x => x.schueler_id)
                        .includes(s.schueler_id) &&
                    s.is_deaktiviert === 0
            );
        if (schuelerInGruppe.length < 1) {
            document.querySelector(`div.ergebnisdateneingabe`).innerHTML =
                `Keine Schüler ${(filterGruppe.typ === 'STAMMKLASSE') ? `der Stammklasse` : `des Kurses`} <i>${filterGruppe.bezeichnung}</i> haben ein Testheft
                im Fach ${Utilities.printFachLang(filter.fach)} zugewiesen.`;
            return false;
        }

        const testsInGruppe: ISchueler_testsAPI[] = this.testliste
            .filter(
                t => {
                    return (
                        schuelerInGruppe.map(s => s.schueler_id).includes(t.schueler_id) &&
                        t.fach === filter.fach
                    )
                }
            ) ?? [];
        if (testsInGruppe.length < 1) {
            document.querySelector(`div.ergebnisdateneingabe`).innerHTML =
                `Keine Schüler ${(filterGruppe.typ === 'STAMMKLASSE') ? `der Stammklasse` : `des Kurses`} <i>${filterGruppe.bezeichnung}</i> haben einen Test
                im Fach ${Utilities.printFachLang(filter.fach)} zugewiesen.`;
            return false;
        }

        Statistik.getInstance().pushStat('ergebnisdateneingabe-aufruf', `fach=${filter.fach}&gruppeid=${filter.gruppeId}`);

        const testheftvarianten = filter.testheftinformation.testhefte;

        const ergebnisdateneingabe = document.querySelector<HTMLDivElement>(`div.ergebnisdateneingabe`);
        if (ergebnisdateneingabe === null)
            return false;
        ergebnisdateneingabe.dataset.testheftvariantenAnzahl = testheftvarianten.length.toString();

        let druckzeilenIndex = 0;
        document.querySelector(`div.ergebnisdateneingabe > div`)
            .innerHTML = schuelerInGruppe.map((s) => {

            let testInFach: ISchueler_testsAPI = this.testliste
                .filter(
                    t => {
                        return (
                            t.schueler_id === s.schueler_id &&
                            t.fach === filter.fach
                        )
                    }
                )[0] ?? null;

            if (testInFach === null) {
                return ``; // Schüler:in wird nicht in diesem Fach getestet
            }

            let testheft: ITestheftAPI = this.testheftliste
                .filter(
                    t => {
                        return (
                            t.testheft_id === testInFach.testheft_id
                        )
                    }
                )[0] ?? null;

            if (testheft === null) {
                return ``; // Testheft existiert nicht
            }

            const isVera5 = this.sessionvariablen.projekt.weiche === 'vera5';
            const aufgaben = testheft.module.flatMap(m => m.aufgaben.map(a => ({...a, modul: m})));
            const druckkopfAnzeigen = druckzeilenIndex % 10 === 0;
            druckzeilenIndex++;

            this.tmp_ItemxPos = 0;
            this.tmp_ItemyPos++;

            return `
            ${(druckkopfAnzeigen === true) ? `
            <div class="only-print ergebnisdaten-druckkopfzeile">
                <div class="schuelerinfos"></div>
                <div class="ergebnisdaten">
                    ${aufgaben.map(a => {
                        const aufgabePosition = (isVera5) ? Utilities.getVera5Aufgabenposition(testheft, a.aufgabe_id, a.position_nr) : a.position_nr;
                        return `
                        <div class="aufgabe" style="--anzahl-items: ${a.items.length}">
                            <div class="items">
                                ${a.items.map(i => `<div class="item">${aufgabePosition}${(a.items.length > 1) ? `.${i.position_bezeichnung}` : ''}</div>`).join('')}
                            </div>
                        </div>`;
                    }).join('')}
                </div>
            </div>` : ''}
            <div class="schueler" data-nr="${s.nr}" data-schuelerid="${s.schueler_id}" data-testid="${testInFach.schueler_test_id}" data-testheftid="${testInFach.testheft_id}" data-nichtanwesend="${testInFach.nicht_anwesend}">
                <div class="schuelerinfos">
                    <div class="eigenschaften">
                        <span class="schuelerbezeichnung">Schüler${(s.geschlecht === 1) ? `` : (s.geschlecht === 2) ? `in` : `:in`}</span> <span class="nummer">${s.nr.toString().padStart(3, '0')}</span>
                        ${(s.geschlecht !== null) ? `
                        <span class="geschlecht">
                            <svg role="graphics-symbol">
                                <use href="/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#gender-${(s.geschlecht === 1) ? 'male' : (s.geschlecht === 2) ? 'female' : (s.geschlecht === 3) ? 'ambiguous' : 'null'}"/>
                            </svg>
                        </span>
                        ` : ``}
                    </div>
                    <div class="klarname">
                        <span data-tresor-anzeige="schueler" data-nr="${s.nr}">______________</span>
                    </div>
                    <div class="testheft-bezeichnung" data-tooltip="${Tooltip.html`
                        <p><strong>${Utilities.printFachLang(filter.fach)}</strong></p>
                        <p>${testheft.bezeichnung}</p>
                    `}">
                        ${testheft.bezeichnung}
                    </div>
                    <div class="optionen">
                        <label class="checkbox-wrapper">nicht anwesend<input type="checkbox" ${(testInFach.nicht_anwesend === 1) ? `checked` : ``}/><span class="checkmark"></span></label>
                    </div>
                </div>
                <div class="ergebnisdaten">
                ${aufgaben.map((a) => {
                    const aufgabeItem = (a.items.length === 1) ? a.items[0] : null;
                    const aufgabeTooltipAttribute = (aufgabeItem === null) ? '' : `data-tooltip-item-id="${aufgabeItem.item_id}" data-tooltip-testheft-id="${testheft.testheft_id}"`;
                    const aufgabeBezeichnungTooltipAttribute = (testheft.fach === 'ma') ? '' : `data-tooltip-aufgabe-id="${a.aufgabe_id}" data-tooltip-testheft-id="${testheft.testheft_id}"`;
                    const aufgabePosition = (isVera5) ? Utilities.getVera5Aufgabenposition(testheft, a.aufgabe_id, a.position_nr) : a.position_nr;
                    return `
                    <div class="aufgabe${(a.items.length === 1) ? ' einzelitem' : ''}" data-aufgabeid="${a.aufgabe_id}" style="--anzahl-items: ${a.items.length}">
                        <div class="bezeichnung">${(isVera5) ? `<span class="aufgabe-nummer" ${aufgabeTooltipAttribute}>Aufgabe ${aufgabePosition}</span>` : `<span class="modul-bezeichnung" ${aufgabeTooltipAttribute}>${a.modul.bezeichnung_kurz} ${a.position_nr}</span>`}<span class="aufgabe-bezeichnung" ${aufgabeBezeichnungTooltipAttribute}>${a.bezeichnung}</span></div>
                        <div class="items">
                        ${a.items
                        .map((i) => {
                            this.tmp_ItemxPos++;
                            this.tmp_ItemIndex++;

                            return `
                            <div class="item" data-itemid="${i.item_id}" data-index="${this.tmp_ItemIndex}"
                            data-x="${this.tmp_ItemxPos}" data-y="${this.tmp_ItemyPos}">
                                ${(isVera5 && a.items.length === 1) ? '' : `<div class="bezeichnung"><span data-tooltip-item-id="${i.item_id}" data-tooltip-testheft-id="${testheft.testheft_id}">${aufgabePosition}.${i.position_bezeichnung}</span></div>`}
                                <div class="ergebnis">
                                    <input type="text" maxlength="1" value="" ${(this.readonlyMode === true) ? `readonly tabindex="-1" placeholder="?"` : ``}/>
                                </div>
                            </div>
                            `;
                        }).join('')}
                        </div>
                    </div>
                    `;
                }).join('')}
                </div>
            </div>`
        }).join('');

        // bereits gespeicherte Ergebnisse in Maske füllen
        if (schuelerInGruppe.length > 0) {
            this.ergebnisseAktualisieren(testsInGruppe);
        }

        // Ergebnisdateneingabemaske editieren und navigieren
        document.querySelectorAll('div.ergebnisdateneingabe div.item div.ergebnis input[type="text"]:not([readonly])')
            .forEach(input => {
                input.addEventListener('keydown', async (evt: KeyboardEvent) => {
                    evt.preventDefault();
                    const target = evt.target as HTMLInputElement;
                    const itemIndex = parseInt((target.closest('div.item[data-itemid]') as HTMLElement)?.getAttribute('data-index') || '') ?? null;
                    const itemXPos = parseInt((target.closest('div.item[data-itemid]') as HTMLElement)?.getAttribute('data-x') || '') ?? null;
                    const itemYPos = parseInt((target.closest('div.item[data-itemid]') as HTMLElement)?.getAttribute('data-y') || '') ?? null;

                    try {
                        // Werte in der Ergebnisdateneingabemaske verändern
                        if (['r', '1'].includes(evt.key)) {
                            if ((target.closest('div.schueler[data-nichtanwesend="1"]') as HTMLElement)?.getAttribute('data-nichtanwesend') === '1') return false;
                            target.value = 'r';
                            (target.closest('div.item[data-itemid]') as HTMLElement).setAttribute('data-ergebnis', '1');
                            (target.closest('div.item[data-itemid]') as HTMLElement).setAttribute('data-changed', '1');
                            await Utilities.delay(100);
                            (document.querySelector(`div.ergebnisdateneingabe div.item[data-index='${itemIndex + 1}'] input[type='text']`) as HTMLInputElement)?.focus();
                        }
                        if (['f', '0', '2'].includes(evt.key)) {
                            if ((target.closest('div.schueler[data-nichtanwesend="1"]') as HTMLElement)?.getAttribute('data-nichtanwesend') === '1') return false;
                            target.value = 'f';
                            (target.closest('div.item[data-itemid]') as HTMLElement).setAttribute('data-ergebnis', '0');
                            (target.closest('div.item[data-itemid]') as HTMLElement).setAttribute('data-changed', '1');
                            await Utilities.delay(100);
                            (document.querySelector(`div.ergebnisdateneingabe div.item[data-index='${itemIndex + 1}'] input[type='text']`) as HTMLInputElement)?.focus();
                        }
                        if (['n', '3'].includes(evt.key)) {
                            if ((target.closest('div.schueler[data-nichtanwesend="1"]') as HTMLElement)?.getAttribute('data-nichtanwesend') === '1') return false;
                            target.value = 'n';
                            (target.closest('div.item[data-itemid]') as HTMLElement).setAttribute('data-ergebnis', '-1');
                            (target.closest('div.item[data-itemid]') as HTMLElement).setAttribute('data-changed', '1');
                            await Utilities.delay(100);
                            (document.querySelector(`div.ergebnisdateneingabe div.item[data-index='${itemIndex + 1}'] input[type='text']`) as HTMLInputElement)?.focus();
                        }
                        if (['Delete'].includes(evt.key)) {
                            target.value = '';
                            (target.closest('div.item[data-itemid]') as HTMLElement).removeAttribute('data-ergebnis');
                            (target.closest('div.item[data-itemid]') as HTMLElement).setAttribute('data-changed', '1');
                            await Utilities.delay(100);
                            (document.querySelector(`div.ergebnisdateneingabe div.item[data-index='${itemIndex + 1}'] input[type='text']`) as HTMLInputElement)?.focus();
                        }
                        if (['Backspace'].includes(evt.key)) {
                            target.value = '';
                            (target.closest('div.item[data-itemid]') as HTMLElement).removeAttribute('data-ergebnis');
                            (target.closest('div.item[data-itemid]') as HTMLElement).setAttribute('data-changed', '1');
                            await Utilities.delay(100);
                            (document.querySelector(`div.ergebnisdateneingabe div.item[data-index='${itemIndex - 1}'] input[type='text']`) as HTMLInputElement)?.focus();
                        }

                        // Navigation in der Ergebnisdateneingabemaske
                        if (['Tab', 'ArrowRight', '6'].includes(evt.key)) {
                            (document.querySelector(`div.ergebnisdateneingabe div.item[data-index='${itemIndex + 1}'] input[type='text']`) as HTMLInputElement)?.focus();
                        }
                        if (['ArrowLeft', '4'].includes(evt.key)) {
                            (document.querySelector(`div.ergebnisdateneingabe div.item[data-index='${itemIndex - 1}'] input[type='text']`) as HTMLInputElement)?.focus();
                        }
                        if (['ArrowDown'].includes(evt.key)) {
                            (document.querySelector(`div.ergebnisdateneingabe div.item[data-x='${itemXPos}'][data-y='${itemYPos + 1}'] input[type='text']`) as HTMLInputElement)?.focus();
                        }
                        if (['ArrowUp'].includes(evt.key)) {
                            (document.querySelector(`div.ergebnisdateneingabe div.item[data-x='${itemXPos}'][data-y='${itemYPos - 1}'] input[type='text']`) as HTMLInputElement)?.focus();
                        }
                        if (['Home'].includes(evt.key)) {
                            (document.querySelector(`div.ergebnisdateneingabe div.item[data-index='1'] input[type='text']`) as HTMLInputElement)?.focus();
                        }
                        if (['End'].includes(evt.key)) {
                            (document.querySelector(`div.ergebnisdateneingabe div.item[data-index='${this.tmp_ItemIndex}'] input[type='text']`) as HTMLInputElement)?.focus();
                        }
                    } catch (e) {
                        Utilities.errorToSentry(e);
                    }
                });
            });

        // Abwesenheit setzen und Ergebnisse an diesem SuS zurücksetzen
        document.querySelectorAll('div.ergebnisdateneingabe div.schueler input[type="checkbox"]')
            .forEach(checkbox => {
                checkbox.addEventListener('change', async (evt) => {
                    const target = evt.target as HTMLInputElement;
                    const schuelerDiv = target.closest('div.schueler') as HTMLDivElement;

                    if (target.checked === true) {
                        const allInputs = schuelerDiv.querySelectorAll<HTMLInputElement>(`div.item[data-itemid] input[type="text"]`);
                        const nonEmptyCount = Array.from(allInputs).filter(input => input.value.trim().length > 0).length ?? 0;

                        if (nonEmptyCount > 5) {
                            const warnungModal = new Modal(this);
                            const warnungModalAntwort = await warnungModal.show({
                                title: `Sollen die Ergebnisse für diesen Schüler wirklich gelöscht werden?`,
                                body: `<p>
                                    Sie möchten einen Schüler nachträglich als <i>"nicht anwesend"</i> markieren, für den bereits Ergebnisdaten in diesem Fach gespeichert wurden.
                                    Wollen Sie den Schüler in diesem Fach wirklich als <i>"nicht anwesend"</i> hinterlegen? Falls ja, werden dessen Ergebnisdaten gelöscht.<br/>
                                    Geben Sie im Bestätigungsfeld <i>'OK'</i> ein, um zu bestätigen, dass Sie die Aktion wirklich durchführen möchten.
                                </p>`,
                                hasSubmit: true,
                                hasCancel: true,
                                hasBestaetigung: true,
                                width: 600,
                                cancelText: 'Abbrechen',
                                submitText: 'Bestätigen'
                            });

                            if (warnungModalAntwort === false) {
                                target.checked = false;
                                return;
                            }
                        }
                    }

                    schuelerDiv.setAttribute('data-nichtanwesend', (target.checked) ? '1' : '0');
                    schuelerDiv.setAttribute('data-changed', '1');
                    schuelerDiv.querySelectorAll(`div.item[data-itemid] input[type="text"]`)
                        .forEach(input => {
                            (input as HTMLInputElement).value = '';
                        });
                    schuelerDiv.querySelectorAll(`div.item[data-itemid]`)
                        .forEach(item => {
                            item.setAttribute('data-changed', '1');
                            item.removeAttribute('data-ergebnis');
                        });
                });
            });

        //region Sprungmarken für Schüler und Item ansteuern
        let sprungmarkeSchuelerNr: number = isNaN(parseInt(this.sessionvariablen.get['schuelernr'])) ? null : parseInt(this.sessionvariablen.get['schuelernr']);
        let sprungmarkeItem: number = isNaN(parseInt(this.sessionvariablen.get['itemid'])) ? null : parseInt(this.sessionvariablen.get['itemid']);

        // zu Schüler (und Item) springen
        try {
            let focusElement: HTMLDivElement = null;
            // zu bestimmter Zeile springen
            if (sprungmarkeSchuelerNr !== null && sprungmarkeItem === null) {
                focusElement = document.querySelector(`div.ergebnisdateneingabe div.schueler[data-nr='${sprungmarkeSchuelerNr}'] div.item[data-x='1']`);
            }
            // zu bestimmtem Item einer Zeile springen
            if (sprungmarkeSchuelerNr !== null && sprungmarkeItem !== null) {
                focusElement = document.querySelector(`div.ergebnisdateneingabe div.schueler[data-nr='${sprungmarkeSchuelerNr}'] div.item[data-itemid='${sprungmarkeItem}']`);
            }
            // zu erstem unausgefüllten Item einer Zeile springen
            if (sprungmarkeSchuelerNr !== null && sprungmarkeItem === null) {
                focusElement = document.querySelector(`div.ergebnisdateneingabe div.schueler[data-nr='${sprungmarkeSchuelerNr}'] div.item:not([data-ergebnis])`);
            }
            // zu erstem unausgefüllten überhaupt springen
            // if (sprungmarkeSchuelerId === null && sprungmarkeItem === null) {
            //     focusElement = document.querySelector(`div.ergebnisdateneingabe div.schueler[data-nr] div.item:not([data-ergebnis])`);
            // }
            if (focusElement !== null) {
                focusElement.scrollIntoView({block: "center", inline: "center"});
                focusElement.closest(`div.schueler`)?.classList.add('sprungmarke-highlight');
                focusElement.closest(`div.aufgabe`)?.classList.add('sprungmarke-highlight');
                setTimeout(() => {
                    focusElement.closest(`div.schueler`)?.classList.remove('sprungmarke-highlight');
                }, 4000);
                setTimeout(() => {
                    focusElement.closest(`div.aufgabe`)?.classList.remove('sprungmarke-highlight');
                }, 6000);
                focusElement.querySelector<HTMLInputElement>(`input[type='text']:not([readonly])`)?.focus();
            }
        } catch (e) {
            Utilities.errorToSentry(e);
        }

        //Die beiden Parameter aus URL-Bar entfernen
        try {
            let url = new URL(window.location.href);
            let params = new URLSearchParams(url.search);
            params.delete('schuelernr');
            params.delete('itemid');
            window.history.pushState({}, document.title, '?' + params.toString());
        } catch {
            //
        }
        //endregion

        return true;
    }

    override async onSeiteFinished(): Promise<boolean> {
        // speichert alle refresh_update_msec die Änderungen in der Ergebnisdateneingabe
        window.setInterval(async () => {
            try {
                if (document.querySelectorAll(`div.ergebnisdateneingabe div.schueler`)?.length > 0)
                    await this.ergebnisseUebermitteln();
            } catch {
                //
            }
        }, this.sessionvariablen.projekt.schuelerinfos_save_msec);


        return true;
    }

    override async onSeiteLeave(): Promise<boolean> {
        await this.ergebnisseUebermitteln();
        return true;
    }

    private ergebnisseAktualisieren(testArr: ISchueler_testsAPI[]): boolean {
        if (document.querySelectorAll(`div.ergebnisdateneingabe > div`)?.length === 0)
            return false;

        let ergebnisse = testArr.flatMap(t => t.ergebnisse);
        if (ergebnisse.length === 0)
            return false;

        try {
            for (const ergebnis of ergebnisse) {
                let itemDOM: HTMLDivElement = document.querySelector(
                    `div.ergebnisdateneingabe > div div.schueler[data-testid='${ergebnis.schueler_test_id}'] div.item[data-itemid='${ergebnis.item_id}']`
                );
                itemDOM.removeAttribute('data-changed');
                itemDOM.setAttribute('data-ergebnis', ergebnis.ergebnis.toString());
                (itemDOM.querySelector(`input[type='text']`) as HTMLInputElement).value = (
                    (ergebnis.ergebnis === 1) ? 'r' :
                        (ergebnis.ergebnis === 0) ? 'f' :
                            (ergebnis.ergebnis === -1) ? 'n' : ''
                );
            }
            return true;
        } catch (e) {
            Utilities.errorToSentry(e);

            return false;
        }
    }

    private async ergebnisseUebermitteln(): Promise<boolean> {

        //region Ergebnisdaten aus DOM parsen
        let changedErgebnisArrDOM: NodeListOf<HTMLDivElement> = document.querySelectorAll('div.ergebnisdateneingabe > div div.item[data-changed="1"]');
        let changedAbwesenheitArrDOM: NodeListOf<HTMLDivElement> = document.querySelectorAll('div.ergebnisdateneingabe > div div.schueler[data-changed="1"]');

        if (changedErgebnisArrDOM.length === 0 && changedAbwesenheitArrDOM.length === 0) {
            return true; // keine veränderten Felder
        }

        let ergebnisse: IErgebnisseDB[] = [];
        changedErgebnisArrDOM
            .forEach((element) => {
                ergebnisse.push({
                    item_id: parseInt(element.getAttribute('data-itemid') || '') ?? null,
                    schueler_id: parseInt(element.closest('div.schueler[data-schuelerid]')?.getAttribute('data-schuelerid') || '') ?? null,
                    schueler_test_id: parseInt(element.closest('div.schueler[data-schuelerid]')?.getAttribute('data-testid') || '') ?? null,
                    testheft_id: parseInt(element.closest('div.schueler[data-testheftid]')?.getAttribute('data-testheftid') || '') ?? null,
                    ergebnis: (Number.isNaN(parseInt(element.getAttribute('data-ergebnis') || '')) ? null : parseInt(element.getAttribute('data-ergebnis') || '')) ?? null,
                    is_cbt: 0
                });
            });
        //endregion

        //region Abwesenheiten aus DOM parsen
        let abwesenheiten: { schueler_id: number; nicht_anwesend: number; schueler_test_id: number; }[] = [];
        changedAbwesenheitArrDOM
            .forEach((element) => {
                abwesenheiten.push({
                    schueler_id: parseInt(element.closest('div.schueler[data-schuelerid]')?.getAttribute('data-schuelerid') || '') ?? null,
                    schueler_test_id: parseInt(element.closest('div.schueler[data-schuelerid]')?.getAttribute('data-testid') || '') ?? null,
                    nicht_anwesend: parseInt(element.closest('div.schueler[data-schuelerid]')?.getAttribute('data-nichtanwesend') || '') ?? 0
                });
            });
        //endregion

        const api = VeraApi.getInstance(this);

        let responseErgebnisse = await api.postErgebnisse(ergebnisse);
        if (responseErgebnisse === true) {
            changedErgebnisArrDOM.forEach((element) => {
                element.setAttribute('data-changed', '0');
            });
        }

        let responseAbwesenheiten = await api.postAbwesenheiten(abwesenheiten);
        if (responseAbwesenheiten === true) {
            changedAbwesenheitArrDOM.forEach((element) => {
                element.setAttribute('data-changed', '0');
            });
        }

    }

}
